import checkIfHeadless from 'src/utils/checkIfHeadless';

export default function lazyload() {
  const targets = document.querySelectorAll(
    'picture:has(img[data-lazy-src]), video:has(source[data-lazy-src])',
  );
  targets.forEach((el) => {
    function callback(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const subEls = el.querySelectorAll(
            '[data-lazy-src], [data-lazy-srcset]',
          );
          subEls.forEach((subEl) => {
            const src = subEl.getAttribute('data-lazy-src');
            const srcset = subEl.getAttribute('data-lazy-srcset');
            if (srcset) {
              subEl.setAttribute('srcset', srcset);
              subEl.removeAttribute('data-lazy-srcset');
            }
            if (src) {
              subEl.setAttribute('src', src);
              subEl.removeAttribute('data-lazy-src');
            }
          });
          if (el.tagName.toLowerCase() === 'video') {
            requestAnimationFrame(() => {
              (el as HTMLVideoElement).load();
            });
          }
          observer.unobserve(entry.target);
        }
      });
    }

    const observer = new IntersectionObserver(callback, {
      rootMargin: '1000px',
      threshold: 0,
    });

    observer.observe(el.querySelector('img') || el);
  });
}
